import Tile from "../Tile/Tile"
import { RecordViewList } from "web/components"
import { useTile } from "web/hooks/data"
import useTileSettingsModal from "web/hooks/data/useTileSettingsModal"
import { TileSummarySettingsModal } from "web/components/Tiles/SummaryTiles/TileSummarySettingsModal"

export default function ViewableSummaryTile({
  canEdit = true,
  fieldActions,
  overview,
  tileFetchParams,
  isDoubleColumn,
}) {
  const tile = useTile({
    tileFetchParams,
  })

  const tileSettingsModal = useTileSettingsModal({
    overview,
    tileSettingsComponent: TileSummarySettingsModal,
    tileTitle: tile.settings_title,
    tileFetchParams,
  })

  async function handleTileSettings() {
    await tileSettingsModal()
  }

  async function handleOnHide() {
    await tile.deleteTile()
  }

  const emptyMessage = "There are currently no summary details to show"

  return (
    <Tile
      handleTileSettings={handleTileSettings}
      handleOnHide={handleOnHide}
      id={tileFetchParams.id}
      title={tile.name}
      canEdit={canEdit}
    >
      <RecordViewList
        data={tile.data ? [tile.data] : []}
        fields={tile.fields}
        fieldActions={fieldActions}
        emptyMessage={emptyMessage}
        showDummyData={false}
        isDoubleColumn={isDoubleColumn}
      />
    </Tile>
  )
}
